import { render, staticRenderFns } from "./ElTableAction.vue?vue&type=template&id=5d1641a6&scoped=true&"
import script from "./ElTableAction.vue?vue&type=script&lang=js&"
export * from "./ElTableAction.vue?vue&type=script&lang=js&"
import style0 from "./ElTableAction.vue?vue&type=style&index=0&id=5d1641a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1641a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VTooltip})
